export const BOOTSTRAP_LOGIN_AUTOMATED = 'BOOTSTRAP_LOGIN_AUTOMATED';
export const BOOTSTRAP_LOGIN_AUTOMATED_LOADED = 'BOOTSTRAP_LOGIN_AUTOMATED_LOADED';
export const BOOTSTRAP_LOGIN_AUTOMATED_ERROR = 'BOOTSTRAP_LOGIN_AUTOMATED_ERROR';



// WEBPACK FOOTER //
// ./src/containers/LoginAutomatedPage/constants.js